import { Instance } from 'mobx-state-tree'
import { GetPromotionCodeIdByCodeResponseModelBase } from './GetPromotionCodeIdByCodeResponseModel.base'

/* The TypeScript type of an instance of GetPromotionCodeIdByCodeResponseModel */
export interface GetPromotionCodeIdByCodeResponseModelType
  extends Instance<typeof GetPromotionCodeIdByCodeResponseModel.Type> {}

/* A graphql query fragment builders for GetPromotionCodeIdByCodeResponseModel */
export {
  selectFromGetPromotionCodeIdByCodeResponse,
  getPromotionCodeIdByCodeResponseModelPrimitives,
  GetPromotionCodeIdByCodeResponseModelSelector
} from './GetPromotionCodeIdByCodeResponseModel.base'

/**
 * GetPromotionCodeIdByCodeResponseModel
 */
export const GetPromotionCodeIdByCodeResponseModel = GetPromotionCodeIdByCodeResponseModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
